function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'lodash';
export const getUserGroups = user => {
  return _.get(user, 'groups', []);
};
const buildSlimUser = user => {
  return _.pick(user, ['email', 'first_name', 'id', 'impersonation_type', 'last_name']);
};
const buildSlimNetworks = user => {
  return _.get(user, 'networks', []).map(network => ({
    id: network.id,
    name: network.name
  }));
};
const buildSlimGroupRoles = group => {
  const roles = _.get(group, 'roles', []);
  return roles.reduce((acc, role) => {
    if (acc.includes(role.name)) {
      return acc;
    }
    return [...acc, role.name];
  }, []);
};
export const getSlimUser = (user, slimGroup) => {
  const group = _.find(_.get(user, 'groups', []), {
    group: {
      id: _.get(slimGroup, 'id')
    }
  });
  return _objectSpread(_objectSpread({}, buildSlimUser(user)), {}, {
    networks: buildSlimNetworks(user),
    roles: buildSlimGroupRoles(group)
  });
};
//# sourceMappingURL=getSlimUser.js.map